// TODO: Change this as soon as we implement the urbantz hook on totadmin
export function getTranslatedPhotoType(photoKey: string): string {
    switch (photoKey) {
        case 'takeGlobal':
            return 'Totem Photo Globale';
        case 'fridge':
            return 'Boissons Fraîches';
        case 'snacks':
            return 'Snacks en Vrac';
        case 'individualSnacks':
            return 'Snacks Individuels';
        case 'fruits':
            return 'Fruits BIO';
        case 'coffee':
            return 'Café & Thé';
        case 'fresh':
            return 'Desserts & Co';
        case 'meal':
            return 'Plats';
        case 'starter':
            return 'Entrées';
        case 'bakery':
            return 'Boulangerie';
        case 'sample':
            return 'Echantillons';
        case 'b2c':
            return 'Livraison B2C';
        case 'frigoRestaurationInventaireSorties':
            return 'Frigo Restauration Inventaire Sorties';
        case 'frigoRestaurationRemplissage':
            return 'Frigo Restauration Remplissage';
        case 'frigoRestaurationRangement':
            return 'Frigo Restauration Rangement';
        case 'frigoBoissonsSorties':
            return 'Frigo Boissons Sorties';
        case 'frigoBoissons':
            return 'Frigo Boissons';
        case 'frigoBoissonsInventaire':
            return 'Frigo Boissons Inventaire';
        case 'colonneSnackSorties':
            return 'Colonne Snack Sorties';
        case 'colonneSnack':
            return 'Colonne Snack';
        case 'colonneSnackInventaire':
            return 'Colonne Snack Inventaire';
        case 'colonneNonAlimentaireSorties':
            return 'Colonne Non Alimentaire Sorties';
        case 'colonneNonAlimentaire':
            return 'Colonne Non Alimentaire';
        case 'colonneNonAlimentaireInventaire':
            return 'Colonne Non Alimentaire Inventaire';
        case 'colonneVracSorties':
            return 'Colonne Vrac Sorties';
        case 'colonneVrac':
            return 'Colonne Vrac';
        case 'colonneBoissonsChaudes':
            return 'Colonne Boissons Chaudes';
        case 'needsFillingMachineNECTA':
            return 'Remplissage Machine à café';
        case 'needsInventoryStockCafe':
            return 'Inventaire Stock Machine à café';
        case 'needsCleaningMachineNECTA':
            return 'Nettoyage Machine à café';
        case 'colonneMicroOndes':
            return 'Colonne Micro-Ondes';
        case 'ColumnPhoto':
            return 'Photo Colonne';
        case 'ColumnStartPhoto':
            return 'Photo Colonne Début';
        case 'TaskStartPhoto':
            return 'Avant';
        case 'TaskPhoto':
            return 'Après';
        case 'ColumnGroupPhoto':
            return 'Photo Colonne Groupe';
        case 'ColumnOpenDoorPhoto':
            return 'Colonne Porte Ouverte';
        case 'ColumnClosedDoorPhoto':
            return 'Colonne Porte Fermée';
        case 'FreefoodGlobalPhoto':
            return 'Photo Globale';
        case 'FreefoodFruit':
            return 'Fruits';
        case 'FreefoodSnacks':
            return 'Snacks';
        case 'FreefoodIndividualSnacks':
            return 'Snacks Individuels';
        case 'FreefoodDessert':
            return 'Desserts';
        case 'FreefoodBreakfast':
            return 'Petit-Déjeuner';
        case 'FreefoodMeal':
            return 'Plats';
        case 'FreefoodStarter':
            return 'Entrées';
        case 'FreefoodColdDrink':
            return 'Boissons Fraîches';
        case 'FreefoodCoffee':
            return 'Café';
        // Legacy : plus généré, conservé pour l'historique
        case 'HotDrinksCleaning':
            return 'Nettoyage Boissons Chaudes';
        case 'HotDrinksCleaningWasteWaterTray':
            return 'Nettoyage Bac Eaux Usées';
        case 'HotDrinksCleaningOpenDoor':
            return 'Nettoyage Porte Ouverte';
        case 'HotDrinksCleaningClosedDoor':
            return 'Nettoyage Porte Fermée';
        case 'HotDrinksMachineWorking':
            return 'Machine en Fonctionnement';
        case 'HotDrinksStartTanks':
            return 'Bacs Boissons Chaudes Début';
        case 'HotDrinksStartStocks':
            return 'Stocks Boissons Chaudes Début';
        case 'HotDrinksStocks':
            return 'Stocks Boissons Chaudes';
        case 'HotDrinksTanks':
            return 'Bacs Boissons Chaudes';
        case 'RemovedItemsPhoto':
            return 'Produits Retirés';
        default:
            return photoKey;
    }
}
